/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getExtractedPackingListTable } from "api/services/documentProcessor";
import { documentProcessorQueryKeys } from "./documentProccessorKeys";

export const useGetExtractedPackingListTable = (filters: any) =>
  useQuery({
    queryKey: documentProcessorQueryKeys.extractedPackingListTable(filters),
    queryFn: () => getExtractedPackingListTable({ params: filters }).then((res) => res.data),
    enabled: !!filters.request_type,
  });
